export const Label = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="mb-2 block font-mono text-[11px] uppercase tracking-[0.16em] text-mist">
    {children}
  </label>
);

const base =
  "w-full border border-white/12 bg-white/[0.02] px-4 py-3 text-[15px] text-bone placeholder:text-mist/60 outline-none transition-colors duration-300 focus:border-saffron";

export const TextField = ({ id, label, ...props }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <input id={id} className={base} data-testid={`field-${id}`} {...props} />
  </div>
);

export const TextArea = ({ id, label, rows = 5, ...props }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <textarea id={id} rows={rows} className={`${base} resize-none`} data-testid={`field-${id}`} {...props} />
  </div>
);

export const SelectField = ({ id, label, options, ...props }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <select id={id} className={`${base} appearance-none`} data-testid={`field-${id}`} {...props}>
      {options.map((o) => (
        <option key={o} value={o} className="bg-ink text-bone">
          {o}
        </option>
      ))}
    </select>
  </div>
);

export const SubmitButton = ({ loading, disabled, children, ...props }) => (
  <button
    type="submit"
    disabled={loading || disabled}
    data-testid="form-submit"
    className="inline-flex items-center justify-center gap-2 bg-saffron px-7 py-3.5 text-sm font-medium text-ink transition-colors duration-300 hover:bg-saffron-dark disabled:opacity-50"
    {...props}
  >
    {loading ? "Sending…" : children}
  </button>
);
